// extracted by mini-css-extract-plugin
export default {"container":"Timeline_container__9z6kk","Main":"Timeline_Main__wt2wL","Wrapper":"Timeline_Wrapper__7WBgJ","Text":"Timeline_Text__mgLpp","Plus":"Timeline_Plus__HgeO+"};